import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { BankAndApp, BtnLogin, BtnRegister, Chars, Logo } from "src/assets";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">FUN678</VisuallyHidden>

      <img
        alt="logo"
        src={Logo}
        style={{ width: 246 }}
      />

      <Stack
        direction="row"
        justifyContent="center"
        zIndex={10}
        gap={2}
        mt={0}
      >
        <a
          href={loginUrl}
          onClick={handleClick("login")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="btn-login"
            src={BtnLogin}
            style={{ height: 67 }}
          />
        </a>
        <a
          href={registerUrl}
          onClick={handleClick("register")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="btn-register"
            src={BtnRegister}
            style={{ height: 67 }}
          />
        </a>
      </Stack>

      <img
        alt="chars"
        src={Chars}
        style={{ width: 336, marginTop: "0px" }}
      />

      <img
        alt="bank-and-app"
        src={BankAndApp}
        style={{ width: 210, marginTop: "6px" }}
      />
    </Box>
  );
};

const styles = createStyles({
  root: {
    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
